"use strict";

angular.module("customer")
.service("OrderConsolidationService", function($resource, appConfig) {
    var partnershipResource = $resource(appConfig.API_SERVER + "/catalog/customer/orders/consolidation/partnerships/", {}, {
        query: {
            method: "get",
            isArray: true
        }
    });
    var queryResource = $resource(appConfig.API_SERVER + "/catalog/customer/orders/consolidation/", {}, {
        query: {
            method: "get",
            isArray: true
        }
    });
    var consolidateResource = $resource(appConfig.API_SERVER + "/catalog/customer/orders/consolidation/submit/", {}, {
        update: {
            method: "POST"
        }
    });

    this.getPartnerships = function() {
        return partnershipResource.query();
    };

    this.query = function(params) {
        return queryResource.query(params);
    };

    this.consolidateOrders = function(orderSourcePartnershipId, productSupplierPartnershipId, orderIds, orderItemType) {
        return consolidateResource.update({
            "order_source_partnership": orderSourcePartnershipId,
            "product_supplier_partnership": productSupplierPartnershipId,
            "orders": orderIds,
            "order_item_type": orderItemType
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/order-consolidation/order-consolidation.service.js
// module id = 948
// module chunks = 0